<div class="modal-container main-font">
  <div class="modal-content-container">
    <div class="modal-header-container">
      <div class="title-container mb-4">
        <p class="modal-title mb-0">
          {{ request ? 'Modifica' : '' }} Malattia da certificare
        </p>
      </div>
      <hr />
    </div>

    <div class="modal-content">
      <form class="form-container" [formGroup]="secondStepForm">
        <div class="d-flex justify-content-center w-100">
          <div class="date-container pe-3 w-100">
            <div class="day-container-sick form-group">
              <span>Giorno di inizio</span>
              <nz-date-picker
                nzFormat="dd/MM/yyyy"
                [nzPlaceHolder]="'Giorno di inizio'"
                formControlName="start_date"
                [nzDisabledDate]="disablePastAndWeekendDates"
                [nzDisabled]="true"></nz-date-picker>
            </div>
            <div class="day-container-sick form-group">
              <span>Giorno di fine</span>
              <nz-date-picker
                nzFormat="dd/MM/yyyy"
                [nzPlaceHolder]="'Giorno di fine'"
                formControlName="end_date"
                [nzDisabledDate]="disableEndDate"></nz-date-picker>
            </div>
          </div>
        </div>
        <app-alert
          message="Invia il certificato o il numero di protocollo entro 24 ore,
            altrimenti sarà considerato un giorno di ferie."></app-alert>
        <div class="protocolNumber">
          <span class="col">Numero di protocollo *</span>
          <input
            nz-input
            class="col inputText w-100 mt-2"
            type="text"
            name="code"
            formControlName="code"
            placeholder="Inserisci numero di protocollo"
            maxlength="13"
            pattern="\d*"
            (keypress)="onlyNumbers($event)" />

          <span
            *ngIf="
              secondStepForm.get('code')?.invalid &&
              secondStepForm.get('code')?.dirty
            "
            class="text-danger">
            Inserisci un minimo di 5 caratteri
          </span>
        </div>

        <div class="protocolNumber">
          <span>Certificato medico</span>
          <div class="row">
            <nz-upload
              [nzMultiple]="false"
              [nzAccept]="'.pdf'"
              [nzFileType]="'application/pdf'"
              class="upload-list-inline"
              nzListType="picture"
              [(nzFileList)]="fileList"
              [nzBeforeUpload]="beforeUpload"
              [nzRemove]="removeFile"
              [nzShowUploadList]="{
                showPreviewIcon: false,
                showRemoveIcon: true,
                showDownloadIcon: false
              }">
              <button nz-button class="uploader-rectangular">
                <img
                  src="./assets/images/icon_request_modal/akar-icons_file.svg"
                  alt="" />
                <span class="pt-2">
                  {{
                    fileList.length > 0
                      ? 'Sostituisci certificato medico'
                      : 'Allega certificato medico'
                  }}
                </span>
              </button>
            </nz-upload>
          </div>
        </div>

        <div class="note-container row">
          <p class="m-0 p-0 text-nate">Contenuto della mail di richiesta</p>
          <nz-textarea-count [nzMaxCharacterCount]="250">
            <textarea
              class="w-100"
              [nzAutosize]="{ minRows: 3, maxRows: 3 }"
              nz-input
              formControlName="note"
              (input)="limitTextLength()"
              placeholder="Scrivi il corpo dell’e-mail">
            </textarea>
          </nz-textarea-count>
        </div>
      </form>
    </div>
    <div class="modal-footer-container">
      <button class="primary-btn-outline-new w-100" (click)="closeModal()">
        Annulla
      </button>
      <button
        class="primary-btn-new w-100"
        (click)="saveSickRequest()"
        [disabled]="secondStepForm.invalid">
        {{ 'Invia' }}
      </button>
    </div>
  </div>
</div>
